
import request from '@/utils/request'
import { ENABLE_API_DBG } from '@/appConfig.js';

function list (params) {
  const {max, offset, ...rest} = params;
  const newParams = {take: max, skip: offset, ...rest};
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    if (!Array.isArray(value)) {
      qsParams.append(key, value);
    }
    else {
      value.forEach(elem => qsParams.append(key, elem));
    }
  }
  //console.log(`api.recshare.list: qsParams = ${qsParams.toString()}`);
  return request({
    url: `/recshare?${qsParams.toString()}`,
    method: 'get',
    data: params
  })
}
function get (itemId) {
  return request({
    url: `/recshare/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/recshare/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/recshare/${itemId}?relation=groups`,
    method: 'get'
  })
}
function search (params) {
  return request({
    url: `/recshare/search`,
    method: 'post',
    data: params
  })
}
function add (params) {
  ENABLE_API_DBG && console.log(`api.recshare.add: params = ${JSON.stringify(params)}`)
  return request({
    url: `/recshare`,
    method: 'post',
    data: params
  })
}
function batchAdd (params) {
  ENABLE_API_DBG && console.log(`api.recshare.batchAdd: params = ${JSON.stringify(params)}`)
  return request({
    url: `/recshare/batchAdd`,
    method: 'post',
    data: params
  })
}
function update (params) {
  const {id, ...outParams} = params;
  const url = `/recshare/${id}`;
  ENABLE_API_DBG && console.log(`api.recshare.update: url = ${url}, outParams = ${JSON.stringify(outParams)}`)
  return request({
    url,
    method: 'patch',
    data: outParams,
  })
}
function remove (itemId) {
  return request({
    url: `/recshare/${itemId}`,
    method: 'delete'
  })
}
export default {
    list,
    search,
    add,
    update,
    remove,
    get,
    getWithTags,
    getWithGroups,
    batchAdd
}
